import ProdutoDcbModel from "../../models/produto/produtoDcbModel";
import { iServiceCached } from "../base/iServiceCached";

class ProdutoDcbService extends iServiceCached<ProdutoDcbModel> {
    constructor() {
        super("ProdutoDcb");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.codigo + " - " + p.descricao,
        }));
    }
}

export default new ProdutoDcbService();
